import { render } from "./PersonaFisica.vue?vue&type=template&id=56b70a4c"
import script from "./PersonaFisica.vue?vue&type=script&lang=js"
export * from "./PersonaFisica.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__